import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { formatToastTime, subscribeToasts } from '../utils/toast';

const TONE_CLASS = {
  ok: 'auth-lite__error--ok',
  error: '',
  warn: 'auth-lite__error--warn',
  info: 'auth-lite__error--info',
};

const TONE_ICON = {
  ok: 'bi-check-lg',
  error: 'bi-exclamation-lg',
  warn: 'bi-exclamation-triangle-fill',
  info: 'bi-info-lg',
};

const AppToast = () => {
  const [items, setItems] = useState([]);

  useEffect(
    () =>
      subscribeToasts((item) => {
        setItems((prev) => [...prev, item]);
        window.setTimeout(() => {
          setItems((prev) =>
            prev.map((row) => (row.id === item.id ? { ...row, leaving: true } : row))
          );
        }, 3800);
        window.setTimeout(() => {
          setItems((prev) => prev.filter((row) => row.id !== item.id));
        }, 4100);
      }),
    []
  );

  if (typeof document === 'undefined' || !items.length) return null;

  return createPortal(
    <div className="kkt-toast-host" aria-live="polite">
      {items.map((item) => (
        <div
          key={item.id}
          className={`auth-lite__error ${TONE_CLASS[item.tone] || ''} ${item.leaving ? 'is-out' : ''}`}
          role={item.tone === 'error' ? 'alert' : 'status'}
        >
          <span className="auth-lite__error-ava" aria-hidden="true">
            <i className={`bi ${TONE_ICON[item.tone] || TONE_ICON.info}`} />
          </span>
          <span className="auth-lite__error-copy">
            <span className="auth-lite__error-head">
              <strong>{item.title}</strong>
              <time>{formatToastTime(item.at)}</time>
            </span>
            {item.text ? <span className="auth-lite__error-text">{item.text}</span> : null}
          </span>
        </div>
      ))}
    </div>,
    document.body
  );
};

export default AppToast;
